import {v4 as uuidv4} from 'uuid';
import img1 from './IMG20231118172036.jpg';
import img2 from "./WhatsApp Image 2025-02-19 at 13.07.26 (1).jpeg"
import img3 from "./WhatsApp Image 2025-02-19 at 13.07.26 (2).jpeg"
import img4 from "./WhatsApp Image 2025-02-19 at 13.07.26 (3).jpeg"
import img5 from "./WhatsApp Image 2025-02-19 at 13.07.26 (4).jpeg"
import img6 from "./WhatsApp Image 2025-02-19 at 13.07.26.jpeg"
import img7 from "./WhatsApp Image 2025-02-19 at 21.53.03.jpeg"
import img8 from "./WhatsApp Image 2025-02-19 at 21.53.35 (1).jpeg"
import img9 from "./WhatsApp Image 2025-02-19 at 21.53.35.jpeg"
import img10 from "./WhatsApp Image 2025-02-24 at 22.38.30.jpeg"
import img11 from "./WhatsApp Image 2025-02-24 at 22.39.31.jpeg"
import img12 from "./WhatsApp Image 2025-02-24 at 22.40.14.jpeg"
import img13 from "./WhatsApp Image 2025-02-24 at 22.41.16.jpeg"
import img14 from "./WhatsApp Image 2025-02-24 at 22.42.01.jpeg"
import img15 from "./WhatsApp Image 2025-02-24 at 22.42.37.jpeg"
import img16 from "./WhatsApp Image 2025-02-24 at 22.43.04.jpeg"
import img17 from "./WhatsApp Image 2025-02-24 at 22.43.50.jpeg"
import img18 from "./WhatsApp Image 2025-02-24 at 22.44.56.jpeg"
import img19 from "./WhatsApp Image 2025-06-10 at 00.58.06.jpeg"
import img20 from "./WhatsApp Image 2025-06-10 at 00.59.52.jpeg"
import img21 from "./WhatsApp Image 2025-06-10 at 01.01.25.jpeg"

// This file is auto-generated
const imagesData = [
    {
      id: uuidv4(),
      src: img1,
      alt: "IMG20231118172036.jpg",
      title: "IMG20231118172036",
      tags: ['courts', 'dégradé','roux','homme', 'tondeuse']
    },
    {
      id: uuidv4(),
      src: img2,
      alt: "WhatsApp Image 2025-02-19 at 13.07.26 (1).jpeg",
      title: "WhatsApp Image 2025-02-19 at 13.07.26 (1)",
      tags: ['courts', 'femme','blonds']
    },
    {
      id: uuidv4(),
      src: img3,
      alt: "WhatsApp Image 2025-02-19 at 13.07.26 (2).jpeg",
      title: "WhatsApp Image 2025-02-19 at 13.07.26 (2)",
      tags: ['courts', 'femme','blonds']
    },
    {
      id: uuidv4(),
      src: img4,
      alt: "WhatsApp Image 2025-02-19 at 13.07.26 (3).jpeg",
      title: "WhatsApp Image 2025-02-19 at 13.07.26 (3)",
      tags: ['longs', 'roux', 'femme','coloration','brushing']
    },
    {
      id: uuidv4(),
      src: img5,
      alt: "WhatsApp Image 2025-02-19 at 13.07.26 (4).jpeg",
      title: "WhatsApp Image 2025-02-19 at 13.07.26 (4)",
      tags: ['courts', 'tondeuse', 'homme', 'ciseaux']
    },
    {
      id: uuidv4(),
      src: img6,
      alt: "WhatsApp Image 2025-02-19 at 13.07.26.jpeg",
      title: "WhatsApp Image 2025-02-19 at 13.07.26",
      tags: ['courts', 'femme','blonds']
    },
    {
      id: uuidv4(),
      src: img7,
      alt: "WhatsApp Image 2025-02-19 at 21.53.03.jpeg",
      title: "WhatsApp Image 2025-02-19 at 21.53.03",
      tags: ['courts', 'femme','blonds']
    },
    {
      id: uuidv4(),
      src: img8,
      alt: "WhatsApp Image 2025-02-19 at 21.53.35 (1).jpeg",
      title: "WhatsApp Image 2025-02-19 at 21.53.35 (1)",
      tags: ['longs', 'femme','blonds']
    },
    {
      id: uuidv4(),
      src: img9,
      alt: "WhatsApp Image 2025-02-19 at 21.53.35.jpeg",
      title: "WhatsApp Image 2025-02-19 at 21.53.35",
      tags: ['longs', 'femme','blonds']
    },
    {
      id: uuidv4(),
      src: img10,
      alt: "WhatsApp Image 2025-02-24 at 22.38.30.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.38.30",
      tags: ['longs', 'brushing', 'femme','roux']
    },
    {
      id: uuidv4(),
      src: img11,
      alt: "WhatsApp Image 2025-02-24 at 22.39.31.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.39.31",
      tags: ['mi-longs', 'coloration', 'argent','femme', 'carré']
    },
    {
      id: uuidv4(),
      src: img12,
      alt: "WhatsApp Image 2025-02-24 at 22.40.14.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.40.14",
      tags: ['mi-longs', 'carré', 'femme','coloration','roux']
    },
    {
      id: uuidv4(),
      src: img13,
      alt: "WhatsApp Image 2025-02-24 at 22.41.16.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.41.16",
      tags: ['longs', 'brushing', 'femme','coloration','roux']
    },
    {
      id: uuidv4(),
      src: img14,
      alt: "WhatsApp Image 2025-02-24 at 22.42.01.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.42.01",
      tags: ['courts', 'dégradé', 'homme', 'tondeuse']
    },
    {
      id: uuidv4(),
      src: img15,
      alt: "WhatsApp Image 2025-02-24 at 22.42.37.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.42.37",
      tags: ['courts', 'carré', 'femme', 'coloration', 'bruns']
    },
    {
      id: uuidv4(),
      src: img16,
      alt: "WhatsApp Image 2025-02-24 at 22.43.04.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.43.04",
      tags: ['homme', 'courts', 'dégradé', 'tondeuse']
    },
    {
      id: uuidv4(),
      src: img17,
      alt: "WhatsApp Image 2025-02-24 at 22.43.50.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.43.50",
      tags: ['mi-longs', 'carré','plongeant', 'femme','bruns']
    },
    {
      id: uuidv4(),
      src: img18,
      alt: "WhatsApp Image 2025-02-24 at 22.44.56.jpeg",
      title: "WhatsApp Image 2025-02-24 at 22.44.56",
      tags: ['mi-longs', 'carré', 'femme','blonds', 'plongeant']
    },
    {
      id: uuidv4(),
      src: img19,
      alt: "WhatsApp Image 2025-06-10 at 00.58.06.jpeg",
      title: "WhatsApp Image 2025-06-10 at 00.58.06",
      tags: ['longs', 'brushing', 'femme','coloration', 'bruns']
    },
    {
      id: uuidv4(),
      src: img20,
      alt: "WhatsApp Image 2025-06-10 at 00.59.52.jpeg",
      title: "WhatsApp Image 2025-06-10 at 00.59.52",
      tags: ['longs', 'brushing', 'coloration','blonds']
    },
    {
      id: uuidv4(),
      src: img21,
      alt: "WhatsApp Image 2025-06-10 at 01.01.25.jpeg",
      title: "WhatsApp Image 2025-06-10 at 01.01.25",
      tags: ['longs', 'brushing', 'femme','coloration', 'bruns']
    }
  ];

export default imagesData;